module.exports = __webpack_public_path__ + "static/media/white_category_icon_c7.ec4faebb.svg";